function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M256.008 457.217L41.4267 242.64C-13.8105 187.399 -13.8095 97.5181 41.4287 42.2799C68.1886 15.52 103.767 0.783173 141.61 0.783173C179.453 0.783173 215.031 15.52 241.79 42.2799L255.999 56.4885L270.208 42.2799C296.967 15.52 332.545 0.783173 370.388 0.783173C408.231 0.783173 443.809 15.52 470.569 42.2789C525.808 97.5181 525.809 187.399 470.571 242.64L256.008 457.217ZM141.611 30.7909C111.783 30.7909 83.7406 42.4069 62.6482 63.4983C19.1099 107.038 19.1099 177.882 62.6462 221.421L256.001 414.786L449.356 221.421C492.892 177.881 492.892 107.038 449.354 63.4983C428.261 42.4069 400.219 30.7909 370.391 30.7909C340.564 30.7909 312.521 42.4059 291.429 63.4983L256.002 98.9255L220.575 63.4983C199.481 42.4069 171.438 30.7909 141.611 30.7909Z",
  fill: "#da6551"
});

function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 458,
    viewBox: "0 0 512 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHeartOutline;